import React, { useState } from "react";

// Helper to remove leading zeroes from date string (YYYY-MM-DD or YYYY-M-D)
function formatDateNoLeadingZero(dateStr) {
  if (!dateStr) return dateStr;
  // Accepts YYYY-MM-DD or YYYY-M-D
  const match = dateStr.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
  if (!match) return dateStr;
  const [, year, month, day] = match;
  return `${parseInt(year, 10)}-${parseInt(month, 10)}-${parseInt(day, 10)}`;
}

// Dictionary mapping gameId to game URLs, use {date} as a placeholder if needed
export const GAME_LINKS = {
  1: "https://denda-games-bucket.s3.eu-central-1.amazonaws.com/Debug_zone/Sudoblock_date_test/index.html?date={date}",
  23: "https://denda-games-bucket.s3.eu-central-1.amazonaws.com/Debug_zone/Rode_Draad_Debug_Param/index.html?debug=true&date={date}",
  35: "https://denda-games-bucket.s3.eu-central-1.amazonaws.com/Release_zone/Rode+Draad+BE/index.html?date={date}",
  37: "https://denda-games-bucket.s3.eu-central-1.amazonaws.com/Debug_zone/Rode+Draad+Sportnieuws/index.html?date={date}",
  21: "https://denda-games-bucket.s3.eu-central-1.amazonaws.com/Debug_zone/Spelwijze_puzzle_fit/index.html?date={date}",
  // Add more gameId: url pairs as needed, use {date} if the game requires a date
};

const GameEmbed = ({ gameId, date, width = 400, height = 900 }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [iframeKey, setIframeKey] = useState(0);
  const [currentSrc, setCurrentSrc] = useState("");

  // Function to build the src URL
  const buildSrc = (gameId, date) => {
    let src = GAME_LINKS[gameId];
    if (!src) return null;
    if (src.includes("{date}")) {
      const formattedDate = formatDateNoLeadingZero(date);
      src = src.replace("{date}", formattedDate || "");
    }
    return src;
  };

  const handleLoadGame = () => {
    const src = buildSrc(gameId, date);
    setCurrentSrc(src);
    setIsLoaded(true);
  };

  const handleReloadGame = () => {
    const src = buildSrc(gameId, date);
    setCurrentSrc(src);
    setIframeKey(prev => prev + 1);
  };

  if (!GAME_LINKS[gameId]) return null;

  return (
    <>
      <div style={{ padding: "10px", textAlign: "center" }}>
        {!isLoaded ? (
          <button 
            onClick={handleLoadGame}
            style={{
              width: "100%",
              padding: "10px 20px",
              fontSize: "16px",
              cursor: "pointer",
              backgroundColor: "#e5e5e5",
              color: "#333",
              border: "1px solid #ccc",
              borderRadius: "4px"
            }}
          >
            Load Game
          </button>
        ) : (
          <button 
            onClick={handleReloadGame}
            style={{
              width: "100%",
              padding: "10px 20px",
              fontSize: "16px",
              cursor: "pointer",
              backgroundColor: "#e5e5e5",
              color: "#333",
              border: "1px solid #ccc",
              borderRadius: "4px"
            }}
          >
            Reload Game
          </button>
        )}
      </div>
      {isLoaded && (
        <div style={{ width, height, border: "1px solid #ccc", borderRadius: 8, overflow: "hidden" }}>
          <iframe
            key={iframeKey}
            src={currentSrc}
            width={width}
            height={height}
            style={{ border: "none" }}
            allowFullScreen
            title="Embedded Game"
          />
        </div>
      )}
    </>
  );
};

export default GameEmbed; 